import React from "react";
import styled from "styled-components";
import { FiChevronDown } from "react-icons/fi";
import { colors } from "./colors";

export default function FilterSelect({ label, value, options, onChange, isDefault }) {
    return (
        <Wrap>
            <Select aria-label={label} value={value} onChange={(event) => onChange(event.target.value)} $default={isDefault}>
                {options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
            </Select>
            <Chevron aria-hidden />
        </Wrap>
    );
}

const Wrap = styled.label`
    position: relative;
    display: inline-flex;
    align-items: center;
    margin: 0;
`;

const Select = styled.select`
    height: 32px;
    appearance: none;
    cursor: pointer;
    border-radius: 8px;
    padding: 0 32px 0 12px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid ${({ $default }) => ($default ? colors.line : `${colors.accent}66`)};
    background: ${({ $default }) => ($default ? colors.surface : colors.accentSoft)};
    color: ${({ $default }) => ($default ? colors.muted : colors.accent)};
    &:hover { border-color: ${colors.lineStrong}; }
`;

const Chevron = styled(FiChevronDown)`
    position: absolute;
    right: 10px;
    pointer-events: none;
    color: ${colors.subtle};
`;
